import SEO from "../../../data/seo";
import HeaderOne from "../../../layout/headers/header-one";
import BannerOne from "./banner";
import About from "./about";
import Services from "./services";
import ChooseUs from "./choose-us";
import Portfolio from "./portfolio";
import CounterUp from "./counter";
import Blog from "./blog";
import FooterTwo from "../../../layout/footers/footer-two";
import Video from "../../about/video";

const HomeOne = () => {
    return (
        <div>
            <SEO pageTitle='Home'/>
            <HeaderOne/>
            <BannerOne/>
            <About/>
            <Services/>
            <ChooseUs/>
            <Portfolio/>
            <CounterUp/>
            <Video/>
            <Blog/>
            <FooterTwo/>
        </div>
    );
};

export default HomeOne;